import React, {useRef, useState, useLayoutEffect} from 'react';
import PropTypes from 'prop-types';
import useWindowDimensions from '../../../hooks/useWindowDimensions';

/**
 *
 * Fills up to the bottom of the screen. This will push any content below it below the fold.
 *
 * Useful for when you have a Menu, content, and a Footer section and want the content section to
 * fill up the the remainder of the screen space.
 */
const FillScreen = ({children = null}) => {
  const containerRef = useRef(null);
  const {height} = useWindowDimensions();
  const [minHeight, setMinHeight] = useState(undefined);

  useLayoutEffect(() => {
    setMinHeight(height - (containerRef.current?.offsetTop || 0));
  }, [height]);

  return (
    <div
      data-testid="fill-screen"
      ref={containerRef}
      style={{minHeight, width: '100%'}}>
      {children}
    </div>
  );
};

FillScreen.propTypes = {
  children: PropTypes.node,
};

export default FillScreen;
